import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('bg');
  const toggleLang = useCallback(() => setLang((l) => (l === 'bg' ? 'en' : 'bg')), []);
  const t = translations[lang];
  const value = useMemo(() => ({ lang, toggleLang, t }), [lang, toggleLang, t]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
